<template>
	<div class="lastMinuteHeader" :data-name="lodging.datestring">
		<h2>{{arrivalFormatted}} {{translations.terms.to}} {{departureFormatted}} ({{durationFormatted}})</h2>
	</div>
</template>

<script>
	import {buildDateFromString} from "@js/globalFunctions/dateHandling";
	import {mapState} from 'vuex';
	export default {
		computed: {
			...mapState({
				translations: 'translations',
			}),
			arrivalDate(){
				return buildDateFromString(this.lodging.datestring,'yyyy-mm-dd');
			},
			departureDate(){
				const departureDate = new Date();
				departureDate.setTime( this.arrivalDate.getTime() + this.lodging.duration * 86400000 );
				return departureDate;
			},
			arrivalFormatted(){
				return this.arrivalDate.getDate()  + "/" + (this.arrivalDate.getMonth()+1);
			},
			departureFormatted(){
				return this.departureDate.getDate()  + "/" + (this.departureDate.getMonth()+1);
			},
			durationFormatted(){
				if(this.lodging.duration % 7 === 0)
				{
					const weeks = this.lodging.duration/7;
					return (weeks === 1) ? '1 '+this.translations.terms.week : weeks+' '+this.translations.terms.weeks;
				}
				else
				{
					return (this.lodging.duration === 1) ? '1 '+this.translations.terms.day : this.lodging.duration+' '+this.translations.terms.days;
				}
			}
		},
		props: {
			lodging: Object
		}
	}
</script>

<style scoped>

</style>
